import React, { useEffect, useRef, useState } from 'react';
import SignalrContext from './SignalrContext';
import { Alert } from 'react-bootstrap';
import { HubConnection, HubConnectionBuilder } from '@microsoft/signalr';
import { ISignalrProviderProps } from './types';
import { localStorageService } from '../../services';

const SignalrProvider: React.FC<ISignalrProviderProps> = ({
  url,
  children,
}) => {
  const hubConnection = useRef<HubConnection>();
  const [connected, setConnected] = useState<boolean>(false);
  const [error, setError] = useState<Error>();

  useEffect(() => {
    const build = (): void => {
      hubConnection.current = new HubConnectionBuilder()
        .withUrl(url, {
          accessTokenFactory: () => localStorageService.getToken() ?? '',
        })
        .withAutomaticReconnect()
        //.configureLogging(LogLevel.Information)
        .build();
    };

    const start = (): void => {
      hubConnection.current
        ?.start()
        .then(() => setConnected(true))
        .catch(setError);
    };

    const stop = () => {
      hubConnection.current
        ?.stop()
        .catch(setError);
    };

    build();
    start();

    return () => stop();
  }, [url]);

  return (
    <>
      {error && <Alert variant="danger">{error.message}</Alert>}
      <SignalrContext.Provider
        value={{
          hub: hubConnection.current,
          connected,
          subscribe: (
            methodName: string,
            newMethod: (...args: any[]) => void,
          ) => hubConnection.current?.on(methodName, newMethod),
          unsubscribe: (methodName: string) =>
            hubConnection.current?.off(methodName),
        }}
      >
        {children}
      </SignalrContext.Provider>
    </>
  );
};

export default SignalrProvider;
